export const limitDateReached = limitDate => {
  if (!limitDate)
    return false;

  const dtLimitDate = new Date(limitDate);
  dtLimitDate.setHours(23, 59, 59, 999);
  const todayDate = new Date();

  return todayDate.getTime() >= dtLimitDate.getTime();
};